/* Полоса-приглашение для гостя: заметная, но не отнимающая доску. */
.hero {
  display: flex;
  align-items: center;
  gap: var(--sp-6);
  padding: var(--sp-5) var(--sp-6);
  background: var(--surface-2);
  border-bottom: 1px solid var(--border);
}

.textWrap {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
}

.title {
  margin: 0;
  font-size: var(--fs-lg);
  font-weight: 700;
  color: var(--text);
}

.lead {
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text-2);
  line-height: 1.45;
}

.actions {
  display: flex;
  gap: var(--sp-3);
  flex: none;
}

@media (max-width: 720px) {
  .hero {
    flex-direction: column;
    align-items: stretch;
    gap: var(--sp-4);
  }

  .actions {
    justify-content: stretch;
  }

  .actions > * {
    flex: 1;
  }
}
